import { render, staticRenderFns } from "./PersonProfileHistoryTable.vue?vue&type=template&id=37de5c1e&scoped=true&"
import script from "./PersonProfileHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryTable.vue?vue&type=style&index=0&id=37de5c1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de5c1e",
  null
  
)

export default component.exports